import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-slate-200" data-id="element-20" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-22" data-mp="1ydi7qcjipzmc">
          <p className="text-blue-600 font-bold tracking-widest uppercase mb-2" data-id="element-23" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-blue-950" data-id="element-24" data-mp="15pw0mub30cuq">
            <span className="text-orange-500" data-id="element-25" data-mp="1jgirk0aloyg9">5</span> PROFESSIONAL BONUS GUIDES
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-26" data-mp="1epiv0w5e8iea">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-amber-50 border border-amber-200/70 rounded-2xl p-8 shadow-sm shadow-blue-950/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="qzy9q6lrp91u" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-blue-950 text-orange-500 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-28" data-mp="2ohio6g5534k0">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-white border border-orange-500/50 rounded-full flex items-center justify-center text-orange-500 mb-4" data-id="element-29" data-mp="1vrs9o5zli0nd">
                <Gift size={24} data-id="element-30" data-mp="20ptv2xkhuc20" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-28 text-blue-950" data-id="element-31" data-mp="25r10wr32t161">{bonus.title}</h3>
              <p className="text-blue-600 text-sm font-semibold mb-4 border-l-4 border-orange-500 pl-4" data-id="element-32" data-mp="3c73c7dg5gs05">
                {bonus.subtitle}
              </p>
              {bonus.intro && <p className="text-slate-800 text-sm mb-4 leading-relaxed" data-id="element-33" data-mp="1h35a3uzy8pws">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-34" data-mp="1c6ev7azvs0cy">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-35" data-mp="1q1zdq5bp6gju">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-36" data-mp="tbq49s8yrqgs">
                        <CheckCircle2 size={16} className="text-blue-600 shrink-0 mt-0.5" data-id="element-37" data-mp="176sgsy8bge2k" />
                        <span className="text-slate-800 text-sm" data-id="element-38" data-mp="12dpmgnvpt0lb">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-39" data-mp="jej83dxu3vh">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-40" data-mp="5awjsqc1u2fx">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-blue-950 font-semibold text-sm bg-white border border-blue-100 rounded-lg px-3 py-2" data-id="element-41" data-mp="3morw96b9bgde">
                        {bullet}
                      </li>)}
                  </ul>
                </>}

              <div className="mt-auto space-y-3" data-id="element-42" data-mp="9aokkgv7b4aq">
                {bonus.system && <div data-id="element-43" data-mp="ea01bpvki9sb">
                    <p className="text-blue-950 font-semibold text-sm mb-2" data-id="element-44" data-mp="e985cdy26a1i">{bonus.systemLabel}</p>
                    <p className="text-white font-bold text-xs sm:text-sm tracking-wide bg-blue-950 border-l-4 border-orange-500 rounded-lg px-3 py-2" data-id="element-45" data-mp="2u0dwal0ly9z7">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-amber-200/70" data-id="element-46" data-mp="3agoeofjerkxi">
                    {bonus.closing.map(line => <p key={line} className="text-blue-950 font-semibold text-sm italic" data-id="element-47" data-mp="35imz44l6y3qs">
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}